'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useState } from 'react';
import { FeatureRoadmapDesktop } from '@/components/page-builder/global/featureRoadmap/FeatureRoadmapDesktop';
import { FeatureRoadmapMobile } from '@/components/page-builder/global/featureRoadmap/FeatureRoadmapMobile';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
type FeatureRoadmapClientProps = {
  readonly categories: Data.Component<'shared.roadmap-category'>[];
  readonly primaryColumnTitle: string;
  readonly secondaryColumnTitle: string;
};
export function FeatureRoadmapClient(t0) {
  const $ = _c(29);
  const {
    categories,
    primaryColumnTitle,
    secondaryColumnTitle
  } = t0;
  const [activeTab, setActiveTab] = useState(primaryColumnTitle);
  let t1;
  if ($[0] !== categories || $[1] !== primaryColumnTitle || $[2] !== secondaryColumnTitle) {
    t1 = <FeatureRoadmapDesktop categories={categories} primaryColumnTitle={primaryColumnTitle} secondaryColumnTitle={secondaryColumnTitle} />;
    $[0] = categories;
    $[1] = primaryColumnTitle;
    $[2] = secondaryColumnTitle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== primaryColumnTitle) {
    t2 = <TabsTrigger value={primaryColumnTitle}>{primaryColumnTitle}</TabsTrigger>;
    $[4] = primaryColumnTitle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== secondaryColumnTitle) {
    t3 = <TabsTrigger value={secondaryColumnTitle}>{secondaryColumnTitle}</TabsTrigger>;
    $[6] = secondaryColumnTitle;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex justify-center mb-6"><TabsList className="w-fit">{t2}{t3}</TabsList></div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== categories) {
    t5 = <FeatureRoadmapMobile categories={categories} column="primary" />;
    $[11] = categories;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== primaryColumnTitle || $[14] !== t5) {
    t6 = <TabsContent value={primaryColumnTitle}>{t5}</TabsContent>;
    $[13] = primaryColumnTitle;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== categories) {
    t7 = <FeatureRoadmapMobile categories={categories} column="secondary" />;
    $[16] = categories;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== secondaryColumnTitle || $[19] !== t7) {
    t8 = <TabsContent value={secondaryColumnTitle}>{t7}</TabsContent>;
    $[18] = secondaryColumnTitle;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== activeTab || $[22] !== t4 || $[23] !== t6 || $[24] !== t8) {
    t9 = <div className="lg:hidden"><Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">{t4}{t6}{t8}</Tabs></div>;
    $[21] = activeTab;
    $[22] = t4;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t1 || $[27] !== t9) {
    t10 = <>{t1}{t9}</>;
    $[26] = t1;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}